import { call, put, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  addArray as addUserGroupsArray
} from 'store/redux/userGroups'
import {
  refresh as refreshViewUserGroups,
  setLoadStatus,
  setCursor,
  addArray as addUserGroupsToView
} from '../redux/userGroups'

export default function * fetchUserGroups (action) {
  const { refresh, type, keyword, limit = 50 } = action.payload

  const batchedActions = []

  if (refresh) {
    batchedActions.push(refreshViewUserGroups())
  }

  batchedActions.push(setLoadStatus({
    loading: true,
    loaded: false
  }))

  yield put(batchedActions)

  const state = yield select()

  const cursor = state['view-userGroups'].userGroups.cursor

  const args = {
    limit
  }

  switch (type) {
    case 'kanbo':
      args.internal = false
      args.external = false
      break
    case 'internal':
      args.internal = true
      args.external = false
      break
    case 'external':
      args.internal = false
      args.external = true
      break
    default:
  }

  if (keyword) args.keyword = keyword
  if (cursor) args.cursor = cursor

  try {
    const { Groups, Cursor } = yield call(apiGetData, 'Groups', args)

    const groups = []
    const viewGroups = []

    Groups.forEach(Group => {
      groups.push({
        id: Group.Id,
        name: Group.Name,
        description: Group.Description,
        internal: Group.Internal,
        external: Group.External,
      })

      viewGroups.push({
        id: Group.Id,
        usersCount: Group.UsersCount
      })
    })

    const batchedActions = [
      addUserGroupsArray(groups),
      addUserGroupsToView(viewGroups),
      setLoadStatus({
        loading: false,
        loaded: !Cursor
      }),
      setCursor(Cursor),
    ]

    yield put(batchedActions)
  } catch (error) {
    yield put(setLoadStatus({
      loading: false,
      loaded: false
    }))

    throw error
  }
}
